import React from 'react';
import ServicesEditTemplate from './services-edit-template'

const StudyPermitServices = () => {
    return <ServicesEditTemplate doc="study_permit" service="Study Permit" />;
};

export default StudyPermitServices;
